// extracted by mini-css-extract-plugin
export default {"detailItem":"detailItem___Oq3rz","label":"label___mx5dY","value":"value___kHE5d"};